import React from "react";

import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useTheme } from "@mui/material/styles";
import downArrow from "../../Assets/Images/Sidebar/down.svg";
// import { Link } from "@mui/material";

const MenuItem = styled.div`
color: rgba(255, 255, 255, 0.8);
display: grid;
padding: 0px 0px;
transition: 0.5s ease-out;
border-radius: 10px;
text-align: center;
justify-items: center;
position: relative;
:hover {
  background: ${(props) => props.hoverBackground};
  border: 0.5px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 3px 0px;
}
  .active-icon-deg{
    rotate: 180deg;
    top:2px;
  }
    .down-icon-arrow{
    right: 4px;
    position: absolute;
        height: 100%;
    display: flex;
    }
`;

function MenuButton(props) {
  const { item,toggleDropdown,openDropdown } = props;
  let navigate = useNavigate();
  const theme = useTheme();


  return (
      <div
      onClick={(event) => {
        if (item.title === "Documents") {
          event.preventDefault();
          event.stopPropagation();
          toggleDropdown(item.title, event); 
        } else {
          navigate(item.link); 
        }
      }}
        style={{ padding: props.padding ? props.padding : '10px 10px'}}
      >
        <MenuItem  title={item.title} hoverBackground={theme.palette.primary.main}>
          <img src={item.icon} alt=""/>
          {item.title}
          {item.title === "Documents" ? <div className={`down-icon-arrow ${openDropdown === item.title ? 'active-icon-deg active-icon' : 'active-icon'}`}><img alt="" src={downArrow}  width="12px"/></div>: ''}
        </MenuItem>
      </div>
  );
}
export default MenuButton;

